import React from 'react'

const Data = () => {
  return (
    <div className="home_data">
      <h1 className='home_title'>Bilgehan Cömert</h1>
      <h3 className='home_subtitle'>Software Developer</h3>
      <p className='home_tech'>Java • Spring Boot • React • Next.js • Full-Stack Development</p>
      <p className="home_description">I build web applications, backend services and internal tools for real business processes.</p>

      <a href="#contact" className="btn btn-primary">Send Message</a>
    </div>
  )
}

export default Data